<template>
  <el-select v-model="selectedState" placeholder="Select state" @change="handleChange">
    <el-option v-for="state in states" :key="state.name" :label="state.name" :value="state.name">
    </el-option>
  </el-select>
</template>

<script>
export default {
  data() {
    return {
      states: [],
      selectedState: "",
      cities: [],
    };
  },
  mounted() {
    this.getAllStatesAndCities();

  },
  methods: {
    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        console.log(response);
        this.states = response.data.findState;
        this.getCitiesInState();
      } catch (error) {
        this.handleError(error);
      }
    },
    getCitiesInState() {
      if (this.selectedState.length) {
        let formattedStateName = this.selectedState
        //   .replace(/\s/g, "")
        //   .replace("State", "")
        //   .toLowerCase();
        this.getCities(formattedStateName);
      }
    },
    async getCities(stateName) {
      this.cities = [];
      try {
        this.cities = [...this.states.find(state => state.name == stateName).cities];
        this.$emit("save-cities", this.cities);
      } catch (error) {
        this.handleError(error);
      }
    },
    handleChange() {
      this.$emit("change", this.selectedState);
      this.getCitiesInState();
    },
  },
};
</script>

<style>
</style>
